import React from "react";

import SEO from "../components/SEO";
import HeaderSection from "../components/partials/resources/HeaderSection";
import NavSection from "../components/partials/resources/NavSection";
import SchoolYearSection from "../components/partials/resources/SchoolYearSection";
import TeacherResourcesSection from "../components/partials/resources/TeacherResourcesSection";
import ParentResourcesSection from "../components/partials/resources/ParentResourcesSection";
import SchoolLeadersResourcesSection from "../components/partials/resources/SchoolLeadersResourcesSection";

const ResourcesPage = () => {
  return (
    <>
      <SEO
        title="page_titles.resources"
        description="page_descriptions.resources"
        image="https://static.classdojo.com/img/page_resources/resourcesFBimage.png"
        twitter={{
          card: "summary_large_image",
          site: "@classdojo",
          creator: "@classdojo",
          title: "Beautiful classroom resources",
          description: "Downloadable ClassDojo artwork, presentations, and more!",
          image: "https://static.classdojo.com/img/page_resources/resourcesFBimage.png",
        }}
      />
      <HeaderSection />
      <NavSection />
      <SchoolYearSection />
      <TeacherResourcesSection />
      <SchoolLeadersResourcesSection />
      <ParentResourcesSection />
    </>
  );
};
export default ResourcesPage;
